import { attr, belongsTo } from '@ember-data/model';
import Super from './document';

export default class InsuranceCard extends Super {
  @attr() file;

  @belongsTo('document-request-contact-info-connection', {
    async: false,
    inverse: 'insuranceCards',
  })
  connection;
  @belongsTo('insurance-info', { async: false, inverse: null }) insuranceInfo;
  @belongsTo('insurance-info-request-connection', { async: false, inverse: null })
  insuranceInfoRequestConnection;
  @belongsTo('insurance-text-extraction', { async: false, inverse: 'insuranceCard' })
  insuranceTextExtraction;

  @attr('string') documentMimeType;
  @attr('string', { defaultValue: null }) insuranceTextExtractionDraftId;
}
